/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargePointFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeUpdateChargePointCommand, type ChargePoint, type ProblemDetails, type UpdateChargePointCommand } from '../../models/index.js';
// @ts-ignore
import { ApiconnectionRequestBuilderRequestsMetadata, type ApiconnectionRequestBuilder } from './apiconnection/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { ConnectionRequestBuilderNavigationMetadata, ConnectionRequestBuilderRequestsMetadata, type ConnectionRequestBuilder } from './connection/index.js';
// @ts-ignore
import { ConsumptionRequestBuilderNavigationMetadata, ConsumptionRequestBuilderRequestsMetadata, type ConsumptionRequestBuilder } from './consumption/index.js';
// @ts-ignore
import { MoveRequestBuilderRequestsMetadata, type MoveRequestBuilder } from './move/index.js';
// @ts-ignore
import { OcppconnectionRequestBuilderRequestsMetadata, type OcppconnectionRequestBuilder } from './ocppconnection/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}
 */
export interface ChargepointsItemRequestBuilder extends BaseRequestBuilder<ChargepointsItemRequestBuilder> {
    /**
     * The apiconnection property
     */
    get apiconnection(): ApiconnectionRequestBuilder;
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The connection property
     */
    get connection(): ConnectionRequestBuilder;
    /**
     * The consumption property
     */
    get consumption(): ConsumptionRequestBuilder;
    /**
     * The move property
     */
    get move(): MoveRequestBuilder;
    /**
     * The ocppconnection property
     */
    get ocppconnection(): OcppconnectionRequestBuilder;
    /**
     * DeleteChargePoint
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetChargePoint
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargePoint>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargePoint | undefined>;
    /**
     * UpdateChargePoint
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateChargePointCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * DeleteChargePoint
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * GetChargePoint
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * UpdateChargePoint
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateChargePointCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointsItemRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargepointsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargepointsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    apiconnection: {
        requestsMetadata: ApiconnectionRequestBuilderRequestsMetadata,
    },
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    connection: {
        requestsMetadata: ConnectionRequestBuilderRequestsMetadata,
        navigationMetadata: ConnectionRequestBuilderNavigationMetadata,
    },
    consumption: {
        requestsMetadata: ConsumptionRequestBuilderRequestsMetadata,
        navigationMetadata: ConsumptionRequestBuilderNavigationMetadata,
    },
    move: {
        requestsMetadata: MoveRequestBuilderRequestsMetadata,
    },
    ocppconnection: {
        requestsMetadata: OcppconnectionRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargepointsItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: ChargepointsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: ChargepointsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargePointFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ChargepointsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateChargePointCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
